export interface IWidgetState {
	isEmpty?: boolean | null;
	isLoading: boolean;
	isError: boolean;
}

export enum IWidgetStates {
	EMPTY = 'empty',
	LOADING = 'loading',
	ERROR = 'error',
	DEFAULT = 'default',
}
